export type Mode = "artist" | "roster";
export type Product = "std" | "pro";
export type Billing = "annual" | "m2m";

/** The plan_key the server stores for a product + billing choice (seeded in core.plans). */
export function planKeyFor(product: Product, billing: Billing): string {
  const base = product === "pro" ? "artist_cntrl_pro" : "artist_cntrl";
  return `${base}_${billing === "annual" ? "annual" : "monthly"}`;
}

/**
 * Whether the application form hides every price (ART-346). Only a visitor the iOS app sent (`from=ios`) is affected,
 * and only outside the US App Store storefront: there, a page the app links to must not sell the subscription. An
 * unknown storefront (an app build too old to report one) hides prices — the safe side of the rule.
 */
export function hidesPricing(from: string | undefined, storefront: string | undefined): boolean {
  return from === "ios" && storefront?.toUpperCase() !== "USA";
}
